import dayjs from 'dayjs';

/**
 * Форматирование даты для чата
 *
 * @param date Дата или строка с датой
 * @returns строку в зависимости от того, сегодня дата, вчера или ранее
 */
export function formatChatDate(date: string | Date | number): { date?: string; time: string } {
  const d = dayjs(date);

  // 1. Если сегодня
  if (d.isSame(dayjs(), 'day')) {
    return { time: d.format('HH:mm') }; // Например: 14:05
  }

  // 2. Если вчера
  if (d.isSame(dayjs().subtract(1, 'day'), 'day')) {
    return { date: 'вчера', time: d.format('HH:mm') }; // Например: "вчера 14:05"
  }

  // 3. Если ранее в этом году (но не вчера/сегодня)
  if (d.isSame(dayjs(), 'year')) {
    return { date: d.format('DD.MM'), time: d.format('HH:mm') }; // Например: 02.05 14:05
  }

  // 4. Если год другой
  return { date: d.format('DD.MM.YYYY'), time: d.format('HH:mm') }; // Например: 10.11.2021 14:05
}
